// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"dbedd075","149":"59c60600","170":"05a70f57","227":"9124d5c2","567":"a679404a","604":"0639a256","786":"35b4be01","912":"c1956e9c","917":"6d19d7a2","980":"6e291797"}[chunkId] + ".chunk.js";
};